import styles from './Tabs.module.css';

export interface TabItem<T extends string> {
  value: T;
  label: string;
  /** Items needing attention; shown as a small red count when above 0. */
  count?: number;
}

/**
 * Admin v2 tabs. `bar` is a page's own tab bar (prototype .hubbar); `inline`
 * sits inside a card under its header (prototype .card .tabs).
 */
export function Tabs<T extends string>({
  items,
  value,
  onChange,
  label,
  variant = 'inline',
}: {
  items: TabItem<T>[];
  value: T;
  onChange: (next: T) => void;
  label: string;
  variant?: 'inline' | 'bar';
}) {
  return (
    <div
      className={[styles.tabs, variant === 'bar' ? styles.bar : '']
        .filter(Boolean)
        .join(' ')}
      role="tablist"
      aria-label={label}
    >
      {items.map((t) => (
        <button
          key={t.value}
          type="button"
          role="tab"
          aria-selected={t.value === value}
          className={[styles.tab, t.value === value ? styles.on : '']
            .filter(Boolean)
            .join(' ')}
          onClick={() => onChange(t.value)}
        >
          {t.label}
          {!!t.count && <span className={styles.count}>{t.count}</span>}
        </button>
      ))}
    </div>
  );
}
